@if(showTypeSelector) {
    <div class="f-row f-center">
        <app-switcher
                [switcherConfig]="config"
                [selectedIndex]="data.isSpecifyDates ? 0 : 1"
                (selectedSwitch)="handleSwitcher($event)"
        ></app-switcher>
    </div>

}
@switch (data.isSpecifyDates) {
    @case (true) {
        <ngx-daterangepicker-material
                [linkedCalendars]="!breakpointService.isMobile()"
                [minDate]="min"
                [startDate]="startDate"
                [endDate]="endDate"
                [dateLimit]="dateLimit"
                (startDateChanged)="setDate($event.startDate, false, dateRangePickerComponent)"
                (endDateChanged)="setDate($event.endDate, true, dateRangePickerComponent)"
                #dateRangePickerComponent
        ></ngx-daterangepicker-material>
    }
    @case (false) {
        <app-duration-container
                [duration]="data.numDays || 12"
                (durationChange)="handleDuration($event)"
        ></app-duration-container>
    }
}
